import update from "immutability-helper";

export const insertItemAt = (array, index, item) => update(array, { $splice: [[index, 0, item]] });
export const deleteItemAt = (array, index, deleteCount = 1) => update(array, { $splice: [[index, deleteCount]] });
